document.addEventListener("DOMContentLoaded", () => {
  const widget = document.getElementById("auzi-language");
  const trigger = document.getElementById("auzi-language-btn");
  const menu = document.getElementById("auzi-language-menu");
  const closeButton = widget?.querySelector(".auzi-language-menu__close");
  const search = document.getElementById("auzi-language-search");
  const empty = document.getElementById("auzi-language-empty");
  const currentFlag = document.getElementById("auzi-current-flag");
  const currentLabel = document.getElementById("auzi-current");
  const shopifyForm = document.getElementById("AuziShopifyLanguageForm");
  const shopifyLocaleInput = document.getElementById("AuziShopifyLocaleCode");

  if (!widget || !trigger || !menu || !currentFlag || !currentLabel) return;

  // Shopify renders the available languages. Do not maintain a second allowlist.
  const options = [...menu.querySelectorAll('[data-lang]')];
  const languages = new Map(options.map(option => [option.dataset.lang.toLowerCase(), option]));
  const shopifyLocale = widget.dataset.shopifyLocale || document.documentElement.lang;
  function findLanguage(code) { return languages.get(String(code).replace('_', '-').toLowerCase()); }

  function updateSwitcher(languageCode) {
    const option = findLanguage(languageCode);
    if (!option) return;
    currentFlag.textContent = option.querySelector('.auzi-language-option__flag')?.textContent || '🌐';
    currentLabel.textContent = option.querySelector('strong')?.textContent || languageCode;

    options.forEach((option) => {
      const isCurrent = option.dataset.lang.toLowerCase() === String(languageCode).toLowerCase();
      option.classList.toggle("is-current", isCurrent);
      option.setAttribute("aria-selected", String(isCurrent));
    });
  }

  function resetSearch() {
    if (!search) return;
    search.value = "";
    options.forEach((option) => { option.hidden = false; });
    if (empty) empty.hidden = true;
  }

  function openMenu() {
    widget.classList.add("open");
    menu.hidden = false;
    trigger.setAttribute("aria-expanded", "true");
    window.setTimeout(() => search?.focus(), 40);
  }

  function closeMenu({ focusTrigger = false } = {}) {
    widget.classList.remove("open");
    menu.hidden = true;
    trigger.setAttribute("aria-expanded", "false");
    resetSearch();
    if (focusTrigger) trigger.focus();
  }

  function switchLanguage(languageCode) {
    const option = findLanguage(languageCode);
    if (!option || !shopifyForm || !shopifyLocaleInput) return;
    if (option.dataset.lang.toLowerCase() === shopifyLocale.toLowerCase()) {
      closeMenu({ focusTrigger: true });
      return;
    }
    // Keep the current label until Shopify confirms the new page's locale.
    shopifyLocaleInput.value = option.dataset.lang;
    if (typeof shopifyForm.requestSubmit === 'function') shopifyForm.requestSubmit();
    else shopifyForm.submit();
  }

  window.AuziLanguage = { switchTo: switchLanguage };

  trigger.addEventListener("click", (event) => {
    event.stopPropagation();
    if (menu.hidden) openMenu(); else closeMenu();
  });

  closeButton?.addEventListener("click", () => closeMenu({ focusTrigger: true }));
  options.forEach((option) => option.addEventListener("click", () => switchLanguage(option.dataset.lang)));

  search?.addEventListener("input", () => {
    const query = search.value.trim().toLocaleLowerCase();
    let visibleCount = 0;

    options.forEach((option) => {
      const haystack = (option.dataset.search || option.textContent).toLocaleLowerCase();
      const isVisible = !query || haystack.includes(query);
      option.hidden = !isVisible;
      if (isVisible) visibleCount += 1;
    });

    if (empty) empty.hidden = visibleCount !== 0;
  });

  document.addEventListener("click", (event) => {
    if (!widget.contains(event.target)) closeMenu();
  });

  document.addEventListener("keydown", (event) => {
    if (event.key === "Escape" && !menu.hidden) closeMenu({ focusTrigger: true });
  });

  window.addEventListener("auzi:language-changed", (event) => {
    if (event.detail?.language) updateSwitcher(event.detail.language);
  });

  updateSwitcher(shopifyLocale);
});


/* Auzi product-form localisation: shared across all product templates. */
(function () {
  var TEXT = {"en": {"hearingBrand": "Hearing Aid Brand", "selectBrand": "— Select brand —", "exactModel": "Exact Model Name", "fit": "We’ll double-check after you order to ensure a perfect fit.", "upload": "Upload a photo", "optional": "optional", "photoNote": "A clear photo of the hearing aid helps us confirm the correct device.", "chooseFile": "Choose file", "noFile": "No file chosen", "other": "Other / Not listed", "cochlearBrand": "Cochlear Brand", "cochlearModel": "Cochlear Model", "modelOther": "Model name (Other)", "modelPlaceholder": "Enter exact model (e.g., RONDO 3)", "battery": "Battery Size", "comments": "Additional comments", "commentsPlaceholder": "Colours, engraving, special requests", "kanso": "Kanso Model", "selectModel": "— Select model —", "preorder": "Pre-order now", "order": "ORDER NOW", "quantity": "Quantity", "inCart": "in cart"}};

  function localeCode() {
    var value = String((window.Shopify && window.Shopify.locale) || document.documentElement.lang || 'en').replace('_', '-').toLowerCase();
    if (value === 'pt-br') return 'pt-BR';
    value = value.split('-')[0];
    return value;
  }

  function decodeEntities(value) {
    var textarea = document.createElement('textarea');
    textarea.innerHTML = String(value == null ? '' : value);
    return textarea.value;
  }

  var localizedForm = document.getElementById('AuziDeviceFormTranslations');
  var formLabels = null;
  if (localizedForm) {
    try {
      formLabels = JSON.parse(localizedForm.textContent);
      Object.keys(formLabels || {}).forEach(function (key) {
        if (typeof formLabels[key] === 'string') formLabels[key] = decodeEntities(formLabels[key]);
      });
    } catch (_) { /* Existing locales retain their current labels. */ }
  }
  var tr = Object.assign({}, TEXT.en, TEXT[localeCode()] || {}, formLabels || {});
  var GIFT_SESSION_KEY = 'auzi.gift.session.v1';
  var MARKET_BRAND_PRIORITY = {
    GB: ['Phonak','Oticon','ReSound','Signia','Widex','Starkey','Bernafon','Unitron','Danalogic','Rexton','Amplifon'],
    US: ['Phonak','Oticon','ReSound','Starkey','Jabra','Beltone','Signia','Widex','Rexton','Unitron'],
    FR: ['Amplifon','Signia','ReSound','Starkey','Phonak','Oticon','Widex','Unitron','Beltone','Bernafon','Hansaton'],
    DE: ['Signia','Widex','Bernafon','Unitron','Hansaton','Oticon','Phonak','ReSound','Starkey','Rexton'],
    AU: ['Phonak','Oticon','Signia','Widex','Starkey','ReSound','Bernafon','Rexton','Unitron'],
    NZ: ['Phonak','Oticon','ReSound','Starkey','Widex','Signia','Unitron','Beltone']
  };

  function storefrontCountry() {
    var code = String((window.Shopify && window.Shopify.country) || '').toUpperCase();
    if (code === 'IE') return 'GB';
    if (code === 'CA') return 'US';
    if (code === 'BE' || code === 'LU') return 'FR';
    if (code === 'AT' || code === 'CH') return 'DE';
    return code;
  }

  function brandPriority() {
    return MARKET_BRAND_PRIORITY[storefrontCountry()] || ['Phonak','Oticon','Signia','ReSound','Widex','Starkey'];
  }

  function normalizedBrand(value) {
    return String(value || '').trim().toLowerCase().replace(/[^a-z0-9]+/g, '');
  }

  function sortBrandSelect(select, prioritized) {
    if (!select || !select.options || select.options.length < 3) return;
    var selected = select.value;
    var all = Array.from(select.options);
    var fixed = all.filter(function (option) {
      return option.disabled || !option.value || /select brand/i.test(option.textContent || '');
    });
    var special = all.filter(function (option) {
      return !fixed.includes(option) && /other|not listed/i.test(option.textContent || '');
    });
    var regular = all.filter(function (option) {
      return !fixed.includes(option) && !special.includes(option);
    });
    var priority = prioritized ? brandPriority().map(normalizedBrand) : [];
    regular.sort(function (a, b) {
      var aName = normalizedBrand(a.textContent || a.value);
      var bName = normalizedBrand(b.textContent || b.value);
      var aIndex = priority.indexOf(aName);
      var bIndex = priority.indexOf(bName);
      if (prioritized && (aIndex !== -1 || bIndex !== -1)) {
        if (aIndex === -1) return 1;
        if (bIndex === -1) return -1;
        if (aIndex !== bIndex) return aIndex - bIndex;
      }
      return String(a.textContent || '').localeCompare(String(b.textContent || ''), undefined, { sensitivity: 'base' });
    });
    var fragment = document.createDocumentFragment();
    fixed.concat(regular, special).forEach(function (option) { fragment.appendChild(option); });
    select.appendChild(fragment);
    if (selected) select.value = selected;
  }

  function readGiftJourney() {
    try {
      var value = JSON.parse(sessionStorage.getItem(GIFT_SESSION_KEY) || 'null');
      return value && value.active === true ? value : null;
    } catch (_) {
      return null;
    }
  }

  function optionForValue(select, value) {
    var wanted = normalizedBrand(value);
    return Array.from(select.options || []).find(function (option) {
      return normalizedBrand(option.value) === wanted || normalizedBrand(option.textContent) === wanted;
    });
  }

  function setSelectValue(select, value) {
    if (!select || !value) return false;
    var option = optionForValue(select, value);
    if (!option) return false;
    if (select.value !== option.value) {
      select.value = option.value;
      select.dispatchEvent(new Event('change', { bubbles: true }));
    }
    return true;
  }

  function setInputValue(input, value) {
    if (!input || !value) return;
    if (input.value === value) return;
    input.value = value;
    input.dispatchEvent(new Event('input', { bubbles: true }));
    input.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function renderGiftDeviceBanner() {
    // Legacy surface retired. Gift/personal device state is rendered only
    // inside the native product device slot.
    document.querySelectorAll('[data-auzi-gift-device-product]').forEach(function (banner) {
      banner.remove();
    });
  }

  function ensureGiftProperty(form, name, value) {
    if (!form || !name || !value) return;
    var existing = form.querySelector('input[data-auzi-gift-property="' + name + '"]');
    if (!existing) {
      existing = document.createElement('input');
      existing.type = 'hidden';
      existing.name = 'properties[' + name + ']';
      existing.setAttribute('data-auzi-gift-property', name);
      form.appendChild(existing);
    }
    existing.value = value;
  }

  function hideGiftField(control) {
    if (!control) return;
    var field = control.closest('.auzi-manual-device__field, .custom-form-field, .product-form__input');
    if (field) field.hidden = true;
    control.disabled = true;
    control.required = false;
  }

  function restoreGiftViewport(y) {
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        if (Math.abs(window.scrollY - y) > 4) {
          window.scrollTo({ top: y, left: 0, behavior: 'auto' });
        }
      });
    });
  }

  function collapseKnownGiftDeviceFields(journey) {
    var info = document.querySelector('product-info');
    if (!info || !journey || !journey.knowsDevice || !journey.device) return;

    var device = journey.device;
    var preserveY = window.scrollY;
    var firstCollapse = info.dataset.auziGiftDeviceCollapsed !== 'true';
    var form = info.querySelector('form[action*="/cart/add"], form[id^="product-form"]') || document.querySelector('form[id^="product-form"]');
    if (form) {
      ensureGiftProperty(form, 'Device Manufacturer', device.brand);
      ensureGiftProperty(form, 'Device Name', device.model);
    }

    if (device.family === 'hearing') {
      info.querySelectorAll('.auzi-manual-device').forEach(function (wrapper) {
        wrapper.querySelectorAll('input, select, textarea').forEach(function (control) {
          if (control.type !== 'hidden') {
            control.disabled = true;
            control.required = false;
          }
        });
        wrapper.hidden = true;
      });

      ['hearing-brand','hearing-model','hearing-photo'].forEach(function (id) {
        hideGiftField(document.getElementById(id));
      });

      info.querySelectorAll('textarea[name="properties[Additional comments]"]').forEach(hideGiftField);
    }

    if (device.family === 'cochlear') {
      ['ci-brand','ci-model','ci-other','ci-notes','kanso-model'].forEach(function (id) {
        hideGiftField(document.getElementById(id));
      });

      info.querySelectorAll(
        '[name="properties[Device Manufacturer]"],[name="properties[Device Name]"],textarea[name="properties[Additional comments]"]'
      ).forEach(function (control) {
        if (control.matches('[data-auzi-gift-property]')) return;
        hideGiftField(control);
      });

      info.querySelectorAll('.auzi-manual-device').forEach(function (wrapper) {
        var visibleFields = Array.from(wrapper.querySelectorAll('.auzi-manual-device__field')).filter(function (field) {
          return !field.hidden;
        });
        if (!visibleFields.length) wrapper.hidden = true;
      });
    }

    info.dataset.auziGiftDeviceCollapsed = 'true';
    if (firstCollapse) restoreGiftViewport(preserveY);
  }

  function prefillGiftDevice() {
    // Device state now has one owner: the native product device slot.
    // Remove any banner created by older cached code and do not hide or
    // duplicate the native hearing/cochlear fields from this language layer.
    renderGiftDeviceBanner();
  }

  function setLabel(controlId, value, mode) {
    var control = document.getElementById(controlId);
    var label = control && control.closest('.custom-form-field') && control.closest('.custom-form-field').querySelector('.custom-form-label');
    if (!label) return;
    label.textContent = value + ' ';
    if (mode === 'required') {
      var star = document.createElement('span');
      star.textContent = '*';
      label.appendChild(star);
    } else if (mode === 'optional') {
      var opt = document.createElement('span');
      opt.style.color = '#c00';
      opt.textContent = '(' + tr.optional + ')';
      label.appendChild(opt);
    }
  }

  function enhanceFileInput() {
    var input = document.getElementById('hearing-photo');
    if (!input) return;
    var existing = input.closest('.auzi-local-file');
    if (!existing) {
      var shell = document.createElement('div');
      shell.className = 'auzi-local-file';
      input.parentNode.insertBefore(shell, input);
      shell.appendChild(input);
      input.classList.add('auzi-local-file__input');

      var button = document.createElement('label');
      button.className = 'auzi-local-file__button';
      button.setAttribute('for', input.id);
      button.setAttribute('data-auzi-file-button', '');
      shell.appendChild(button);

      var name = document.createElement('span');
      name.className = 'auzi-local-file__name';
      name.setAttribute('data-auzi-file-name', '');
      shell.appendChild(name);

      input.addEventListener('change', function () {
        name.textContent = input.files && input.files[0] ? input.files[0].name : tr.noFile;
      });
      existing = shell;
    }
    var fileButton = existing.querySelector('[data-auzi-file-button]');
    var fileName = existing.querySelector('[data-auzi-file-name]');
    if (fileButton) fileButton.textContent = tr.chooseFile;
    if (fileName && !(input.files && input.files[0])) fileName.textContent = tr.noFile;
  }

  function translateOptions() {
    var map = {
      '— Select brand —': tr.selectBrand,
      'Other / Not listed': tr.other,
      '— Select model —': tr.selectModel
    };
    document.querySelectorAll('#hearing-brand option, #ci-brand option, #ci-model option, #kanso-model option').forEach(function (option) {
      var source = option.getAttribute('data-auzi-source') || option.textContent.trim();
      option.setAttribute('data-auzi-source', source);
      if (map[source]) option.textContent = map[source];
    });
    sortBrandSelect(document.getElementById('hearing-brand'), true);
    sortBrandSelect(document.getElementById('ci-brand'), false);
  }

  function applyFormTranslations() {
    setLabel('hearing-brand', tr.hearingBrand, 'required');
    setLabel('hearing-model', tr.exactModel, 'required');
    setLabel('hearing-photo', tr.upload + ' (' + tr.optional + ')');
    setLabel('ci-brand', tr.cochlearBrand, 'required');
    setLabel('ci-model', tr.cochlearModel, 'required');
    setLabel('ci-other', tr.modelOther, 'required');
    setLabel('battery-size', tr.battery, 'required');
    setLabel('ci-notes', tr.comments, 'optional');
    setLabel('kanso-model', tr.kanso, 'required');

    var helper = document.querySelector('#hearing-model + .custom-helper-text');
    if (helper) helper.textContent = tr.fit;
    var note = document.querySelector('#hearing-photo ~ small.note, .auzi-local-file + small.note');
    if (note) note.textContent = tr.photoNote;
    var other = document.getElementById('ci-other');
    if (other) other.placeholder = tr.modelPlaceholder;
    var comments = document.getElementById('ci-notes');
    if (comments) comments.placeholder = tr.commentsPlaceholder;

    translateOptions();
    enhanceFileInput();
    prefillGiftDevice();

    document.querySelectorAll('.product-form__submit span').forEach(function (span) {
      var value = span.textContent.trim().toLowerCase();
      if (value === 'order now') span.textContent = tr.order;
      if (value === 'pre-order now') span.textContent = tr.preorder;
    });

    document.querySelectorAll('.product-form__quantity .quantity__label, label.quantity__label').forEach(function (label) {
      var value = label.textContent.trim();
      var match = value.match(/\((\d+)\s+in cart\)/i);
      if (value.toLowerCase().indexOf('quantity') === 0) {
        label.textContent = tr.quantity + (match ? ' (' + match[1] + ' ' + tr.inCart + ')' : '');
      }
    });
  }

  if (!document.getElementById('auzi-local-file-styles')) {
    var style = document.createElement('style');
    style.id = 'auzi-local-file-styles';
    style.textContent = '.auzi-local-file{display:flex;align-items:center;gap:10px;min-height:45px;padding:6px 10px;border:1px solid #ccc;background:#fff}.auzi-local-file__input{position:absolute!important;width:1px!important;height:1px!important;overflow:hidden!important;opacity:0!important;pointer-events:none!important}.auzi-local-file__button{flex:0 0 auto;padding:5px 10px;border:1px solid #777;background:#f7f7f7;cursor:pointer;font-size:1.2rem}.auzi-local-file__name{min-width:0;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;font-size:1.2rem}.auzi-gift-device-product{display:grid;grid-template-columns:68px minmax(0,1fr);align-items:center;gap:13px;margin:10px 0 16px;padding:11px 13px;border:1px solid #d8c7ad;border-radius:15px;background:linear-gradient(135deg,#fffdf8,#f8f3eb);color:#2d2924;box-shadow:0 8px 24px rgba(90,65,31,.06)}.auzi-gift-device-product__photo{position:relative;width:68px;height:68px;overflow:hidden;border:1px solid #e3dbcf;border-radius:12px;background:#fff}.auzi-gift-device-product__photo img{width:100%;height:100%;object-fit:contain;padding:6px}.auzi-gift-device-product__photo span{display:grid;width:100%;height:100%;place-items:center;color:#b08a51;font:600 8px/1 Arial,sans-serif;letter-spacing:.16em}.auzi-gift-device-product__copy{display:grid;justify-items:start;gap:4px;min-width:0}.auzi-gift-device-product__copy small{display:flex;align-items:center;gap:5px;color:#5f7554;font:700 8px/1.15 Arial,sans-serif;letter-spacing:.11em}.auzi-gift-device-product__copy small span{display:grid;place-items:center;width:15px;height:15px;border-radius:50%;background:#e9f1e5;color:#58704e;font-size:9px}.auzi-gift-device-product__logo{display:block;width:auto;max-width:92px;height:19px;object-fit:contain;object-position:left center}.auzi-gift-device-product__copy strong{max-width:100%;font-family:var(--font-heading-family,Georgia,serif);font-size:17px;font-weight:400;line-height:1.15;white-space:normal}';
    document.head.appendChild(style);
  }

  document.addEventListener('change', function (event) {
    if (event.target && /^(hearing-brand|ci-brand|ci-model|kanso-model)$/.test(event.target.id)) {
      window.setTimeout(applyFormTranslations, 0);
    }
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', applyFormTranslations);
  else applyFormTranslations();
  var translationQueued = false;
  function queueTranslations() {
    if (translationQueued) return;
    translationQueued = true;
    requestAnimationFrame(function () {
      translationQueued = false;
      formObserver.disconnect();
      applyFormTranslations();
      formObserver.observe(document.body, { childList: true, subtree: true });
    });
  }
  var formObserver = new MutationObserver(function (records) {
    if (records.some(function (record) {
      return [...record.addedNodes].some(function (node) {
        return node.nodeType === 1 && (node.matches('.custom-form-field, .product-form, product-info, option') || node.querySelector('.custom-form-field, .product-form'));
      });
    })) queueTranslations();
  });
  if (document.body) formObserver.observe(document.body, { childList: true, subtree: true });
  document.addEventListener('shopify:section:load', queueTranslations);
}());